"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordGuard = exports.record = void 0;
var guard_1 = require("../guard");
/**
 * Constructs a type-guard for the `Record` type
 * @param keyGuard type-guard for a key in the record
 * @param valueGuard type-guard for a value in the record
 */
function record(keyGuard, valueGuard) {
    return new RecordGuard(keyGuard, valueGuard);
}
exports.record = record;
function isPlainObject(obj) {
    return (typeof obj === 'object' && // separate from primitives
        obj !== null && // is obvious
        obj.constructor === Object && // separate instances (Array, DOM, ...)
        Object.prototype.toString.call(obj) === '[object Object]'); // separate build-in like Math
}
var RecordGuard = /** @class */ (function (_super) {
    __extends(RecordGuard, _super);
    function RecordGuard(keyGuard, valueGuard) {
        var _this = this;
        if (keyGuard instanceof guard_1.Guard === false) {
            throw new Error('"key" must an instance of TypeGuard');
        }
        if (valueGuard instanceof guard_1.Guard === false) {
            throw new Error('"value" must an instance of TypeGuard');
        }
        _this = _super.call(this, {
            type: 'record',
            coerce: function (path, value, coercer) {
                if (isPlainObject(value)) {
                    return Object.entries(value).reduce(function (acc, _a) {
                        var _b;
                        var _c = __read(_a, 2), key = _c[0], propValue = _c[1];
                        return __assign(__assign({}, acc), (_b = {}, _b[keyGuard.coerce(path, key, coercer)] = valueGuard.coerce(__spreadArray(__spreadArray([], __read(path), false), [key], false), propValue, coercer), _b));
                    }, {});
                }
                return value;
            },
            validate: function (path, value) {
                var _a, _b, _c, key, propValue, e_1_1;
                var e_1, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (!isPlainObject(value)) return [3 /*break*/, 10];
                            _e.label = 1;
                        case 1:
                            _e.trys.push([1, 7, 8, 9]);
                            _a = __values(Object.entries(value)), _b = _a.next();
                            _e.label = 2;
                        case 2:
                            if (!!_b.done) return [3 /*break*/, 6];
                            _c = __read(_b.value, 2), key = _c[0], propValue = _c[1];
                            return [5 /*yield**/, __values(keyGuard.validate(path, key))];
                        case 3:
                            _e.sent();
                            return [5 /*yield**/, __values(valueGuard.validate(__spreadArray(__spreadArray([], __read(path), false), [key], false), propValue))];
                        case 4:
                            _e.sent();
                            _e.label = 5;
                        case 5:
                            _b = _a.next();
                            return [3 /*break*/, 2];
                        case 6: return [3 /*break*/, 9];
                        case 7:
                            e_1_1 = _e.sent();
                            e_1 = { error: e_1_1 };
                            return [3 /*break*/, 9];
                        case 8:
                            try {
                                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                            }
                            finally { if (e_1) throw e_1.error; }
                            return [7 /*endfinally*/];
                        case 9: return [3 /*break*/, 12];
                        case 10: return [4 /*yield*/, {
                                path: path,
                                rule: 'type',
                                setting: 'record',
                                actual: value
                            }];
                        case 11:
                            _e.sent();
                            _e.label = 12;
                        case 12: return [2 /*return*/];
                    }
                });
            },
            convert: function (path, value, converter) {
                return Object.entries(value).reduce(function (acc, _a) {
                    var _b;
                    var _c = __read(_a, 2), key = _c[0], propValue = _c[1];
                    var convertedKey = keyGuard.convert(path, key, converter);
                    var convertedValue = valueGuard.convert(__spreadArray(__spreadArray([], __read(path), false), [key], false), propValue, converter);
                    return __assign(__assign({}, acc), (_b = {}, _b[convertedKey] = convertedValue, _b));
                }, {});
            },
            scan: function (path, value, scanner) {
                var _a, _b, _c, key, propValue, e_2_1;
                var e_2, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            _e.trys.push([0, 6, 7, 8]);
                            _a = __values(Object.entries(value)), _b = _a.next();
                            _e.label = 1;
                        case 1:
                            if (!!_b.done) return [3 /*break*/, 5];
                            _c = __read(_b.value, 2), key = _c[0], propValue = _c[1];
                            return [5 /*yield**/, __values(keyGuard.scan(path, key, scanner))];
                        case 2:
                            _e.sent();
                            return [5 /*yield**/, __values(valueGuard.scan(__spreadArray(__spreadArray([], __read(path), false), [key], false), propValue, scanner))];
                        case 3:
                            _e.sent();
                            _e.label = 4;
                        case 4:
                            _b = _a.next();
                            return [3 /*break*/, 1];
                        case 5: return [3 /*break*/, 8];
                        case 6:
                            e_2_1 = _e.sent();
                            e_2 = { error: e_2_1 };
                            return [3 /*break*/, 8];
                        case 7:
                            try {
                                if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                            }
                            finally { if (e_2) throw e_2.error; }
                            return [7 /*endfinally*/];
                        case 8: return [2 /*return*/];
                    }
                });
            },
            substitute: function (path, replacer) {
                return record(replacer(keyGuard, path), replacer(valueGuard, path));
            }
        }) || this;
        _this.key = keyGuard;
        _this.value = valueGuard;
        return _this;
    }
    return RecordGuard;
}(guard_1.Guard));
exports.RecordGuard = RecordGuard;
